import {
  ref,
  reactive,
  onBeforeMount,
  getCurrentInstance,
  watch,
  computed,
} from "@vue/composition-api";
import router from "@/router";
import store from "@/store";
import useValidationModal from "@/@core/components/base-modal/hooks/useValidationModal";
import usePagination from "@/views/components/pagination/usePagination";
import useFilterHeaderTable from "@/views/components/filter-header-table/useFilterHeaderTable";
import useDownloadFile from "@/utils/hooks/useDownloadFile";
import { uploadPointModel } from "@/models/ais-point/upload-point";

export default function useUploadPointinfo() {
  const vm = getCurrentInstance().proxy;

  const {
    openSuccessModal,
    openDefaultErrorModal,
    openErrorModal,
    openWarningModal,
  } = useValidationModal();

  const {
    filters,
    ordering,
    onSetValueSearch,
    sortingChanged,
    onSelectFilter,
  } = useFilterHeaderTable();

  const { pagination, onPageChange, onFilterEntity } = usePagination();

  const {
    createCampaignModel,
    editCampaignModel,
    getCampaignDetailModel,
    ExportCampaignModel,
    actionCampaignModel,
    RefCodeModel,
  } = uploadPointModel();

  const { onDownloadFile } = useDownloadFile();

  const loading = reactive({
    tableData: false,
  });

  const status = reactive({
    SUCCESS: 9,
    AWAIT_APPROVAL: 2,
    IN_PROGRESS: 5,
    DRAFTED: 1,
    REJECT: 11,
  });

  const statusAction = reactive({
    CONFIRM: 1,
    APPROVE: 2,
    REJECT: 3,
  });

  const isCreate = ref(false);
  const isEdit = ref(false);
  const isPreview = ref(false);
  const isComfirm = ref(false);

  const fields = [
    { key: "seq", label: "No." },
    { key: "mobileno", label: "Mobile Phone" },
    { key: "point", label: "Point", sortable: true },
    { key: "status", label: "Status", sortable: true },
    { key: "message_th", label: "Note" },
  ];

  const resolveUploadPointInfoStatus = (status) => {
    switch (status) {
      case 9:
        return "Success";
      case 10:
        return "Failed";
      case 12:
        return "Failed";
      default:
        return " ";
    }
  };

  const resolveClassUploadPointInfoStatus = (status) => {
    switch (status) {
      case 9:
        return "success";
      case 10:
        return "failed";
      case 12:
        return "failed";
      default:
        return " ";
    }
  };

  const formData = reactive({
    CampaignId: null,
    refCode: null,
    CamplaignRef: null,
    campaignName: null,
    description: null,
    totalUsers: null,
    totalPoint: null,
    fileUpload: null,
    templateUrl: null,
  });

  const previewDataListTable = reactive({
    payload: [],
  });

  const refCodeOption = reactive({
    refCode: [],
  });

  const checkFormCreateOrEdit = () => {
    isCreate.value = false;
    isEdit.value = false;
    isPreview.value = false;
    isComfirm.value = false;

    if (router.currentRoute.params.id) {
      formData.CampaignId = router.currentRoute.params.id;
      fetcCampaignDetail();
    } else {
      isCreate.value = true;
    }
  };

  const createCampaign = () => {
    window.$loading(true);
    createCampaignModel.payload.EXC_AssetId = formData.refCode;
    createCampaignModel.payload.Campaign_Name = formData.campaignName;
    createCampaignModel.payload.Detail = formData.description;
    store
      .dispatch("api/apiRequest", createCampaignModel)
      .then((response) => {
        let resp = response.data;
        openSuccessModal(null, null, null, () =>
          router.push(
            `/point-exchange/upload-point/upload-point-info/${resp.campaign_info.campaignid}`
          )
        );
      })
      .catch((error) => {
        openDefaultErrorModal(error);
      })
      .finally(() => {
        window.$loading(false);
      });
  };

  const editCampaign = (flgUpload) => {
    window.$loading(true);
    editCampaignModel.payload.Campaign_Id = router.currentRoute.params.id;
    editCampaignModel.payload.EXC_AssetId = formData.refCode;
    editCampaignModel.payload.Campaign_Name = formData.campaignName;
    editCampaignModel.payload.Detail = formData.description;
    if (flgUpload) editCampaignModel.payload.Import_File = formData.fileUpload;
    store
      .dispatch("api/apiFormRequest", editCampaignModel)
      .then((response) => {
        let resp = response.data;
        if (flgUpload) {
          checkFormCreateOrEdit();
        } else {
          openSuccessModal("ทำรายการสำเร็จ !", null, "ตกลง", () =>
            fetcCampaignDetail()
          );
        }
      })
      .catch((error) => {
        const errorResponse = error.data.error;
        if (errorResponse?.code == 9291001) {
          const title = errorResponse?.locale["th-th"]?.title;
          const detail = errorResponse?.locale["th-th"]?.message;
          openErrorModal(title, detail);
        } else {
          openDefaultErrorModal(error);
        }
      })
      .finally(() => {
        window.$loading(false);
      });
  };

  const fetcCampaignDetail = () => {
    window.$loading(true);
    loading.tableData = true;
    getCampaignDetailModel.payload.Campaign_Id = router.currentRoute.params.id;
    getCampaignDetailModel.payload.Page = pagination.currentPage;
    getCampaignDetailModel.payload.Limit = pagination.perPage;
    getCampaignDetailModel.payload.Filters = filters;
    getCampaignDetailModel.payload.Ordering = ordering.value;
    store
      .dispatch("api/apiRequest", getCampaignDetailModel)
      .then((response) => {
        let resp = response.data;
        formData.refCode = resp.campaign_info.exc_assetid; // refCode = exc_assetid
        formData.CamplaignRef = resp.campaign_info.alt_reference;
        formData.campaignName = resp.campaign_info.campaign_name;
        formData.description = resp.campaign_info.detail;
        formData.totalUsers = resp.campaign_info.total_mobileno;
        formData.totalPoint = resp.campaign_info.total_point;
        formData.templateUrl = resp.campaign_info.templateurl;
        if (
          resp.campaign_info.status == status.SUCCESS ||
          resp.campaign_info.status == status.REJECT
        ) {
          isPreview.value = true;
        } else if (resp.filtered_record > 0) {
          isComfirm.value = true;
        } else {
          isEdit.value = true;
        }

        previewDataListTable.payload = resp.preview_data;
        pagination.rows = resp.preview_data.length;
        pagination.totalRows = resp.filtered_record;
      })
      .catch((error) => {
        openDefaultErrorModal(error);
      })
      .finally(() => {
        window.$loading(false);
        loading.tableData = false;
      });
  };

  const fetcRefCode = () => {
    loading.tableData = true;
    store
      .dispatch("api/apiRequest", RefCodeModel)
      .then((response) => {
        refCodeOption.refCode = response.data.payload;
      })
      .catch((error) => {
        openDefaultErrorModal(error);
      })
      .finally(() => {
        loading.tableData = false;
      });
  };

  const onSubmitExport = () => {
    let fileName = formData.campaignName + "_AIS_Point_Report";
    ExportCampaignModel.payload.Campaign_Id = router.currentRoute.params.id;
    store
      .dispatch("api/apiRequest", ExportCampaignModel)
      .then((response) => {
        onDownloadFile(response, fileName, ".csv");
      })
      .catch((error) => {
        loading.tableData = false;
        openErrorModal(error);
      })
      .finally(() => {});
  };

  const onSubmitConfirm = () => {
    loading.tableData = true;
    openWarningModal(
      "ยืนยันการอัปโหลด Points",
      "ต้องการยืนยันการอัปโหลด Points ใช่หรือไม่",
      () => {
        actionCampaignModel.payload.Campaign_Id = router.currentRoute.params.id;
        actionCampaignModel.payload.Action_Id = statusAction.CONFIRM;
        store
          .dispatch("api/apiRequest", actionCampaignModel)
          .then((response) => {
            router.push("/point-exchange/upload-point/upload-point-list");
          })
          .catch((error) => {
            loading.tableData = false;
            openErrorModal(error);
          })
          .finally(() => {
            loading.tableData = false;
          });
      },
      null,
      null,
      "",
      false,
      false,
      "text-success"
    );
    loading.tableData = false;
  };

  const onSubmit = async () => {
    if (isCreate.value) {
      createCampaign();
    } else {
      editCampaign(false);
    }
  };

  const onNextStep = () => {
    editCampaign(true);
  };

  const textUpload = reactive({
    textHeader: [
      {
        text: "Please upload a CSV file that only contains",
      },
      {
        text:
          "<br>user <b><u>Mobile phone number</u></b> and <b><u>Points</u></b></br>",
      },
    ],
    textFooter: [
      {
        text:
          "<li>A single file can only contain up to 10,000 mobile numbers.</li>",
      },
      {
        text:
          "<li>Your file won’t be upload if it contains an incorrectly formatted or duplicate mobile number.</li>",
      },
    ],
  });

  const isNext = ref(true);

  const onInputFile = (file) => {
    formData.fileUpload = file;
    if (file) {
      isNext.value = false;
    } else {
      isNext.value = true;
    }
  };

  watch(
    pagination,
    () => {
      if (!loading.tableData) {
        checkFormCreateOrEdit();
      }
    },
    { deep: true }
  );

  watch(
    [filters, ordering],
    () => {
      pagination.currentPage = 1;

      checkFormCreateOrEdit();
    },
    { deep: true }
  );

  onBeforeMount(() => {
    checkFormCreateOrEdit();
    fetcRefCode();
  });

  return {
    loading,
    fields,
    formData,
    isCreate,
    isEdit,
    isComfirm,
    isPreview,
    isNext,
    textUpload,
    previewDataListTable,
    refCodeOption,
    pagination,
    onPageChange,
    onFilterEntity,
    sortingChanged,
    onSetValueSearch,
    onSelectFilter,
    onSubmit,
    onSubmitExport,
    onSubmitConfirm,
    onInputFile,
    onNextStep,
    resolveUploadPointInfoStatus,
    resolveClassUploadPointInfoStatus,
  };
}
